import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

export const fetchTransfer = createAsyncThunk(
  "transfer/fetchTransfer",
  async ({ month, year } = {}, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/userlist/transfer-history?month=${month || ""}&year=${year || ""}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch transfers." }
      );
    }
  }
);

export const transferData = createAsyncThunk(
  "transfer/transferData",
  async (datas, { rejectWithValue }) => {
    const token = getToken();
    
    if (!token) {
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });
    }

    try {
      const response = await axios.post(
        `${Apiurl}admin/userlist/update-user-id`,
        datas, 
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Data Transfer",
        text: "Data transferred successfully",
        timer: 3000,
      });

      return response.data;

    } catch (error) {
      // Enhanced error handling
      const errorMessage = error.response?.data?.message || "Please try again later.";
      
      Swal.fire({
        icon: "error",
        title: "Transfer Failed",
        text: errorMessage,
        timer: 3000,
      });

      return rejectWithValue(
        error.response?.data || { 
          message: errorMessage,
          status: error.response?.status 
        }
      );
    }
  }
);

const initialState = {
  transferData: [],
  loading: false,
  status: "idle",
  transferStatus: "idle",
  error: null,
};

const transferSlice = createSlice({
  name: "transfer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransfer.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchTransfer.fulfilled, (state, action) => {
        state.transferData = action.payload.data;
        state.status = "succeeded";
      })
      .addCase(fetchTransfer.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(transferData.pending, (state) => {
        state.error = null;
        state.transferStatus = "pending";
      })
      .addCase(transferData.fulfilled, (state, action) => {
        state.transferData = action.payload;
        state.transferStatus = "succeeded";
      })
      .addCase(transferData.rejected, (state, action) => {
        state.error = action.payload;
        state.transferStatus = "failed";
      });
  },
});

export default transferSlice.reducer;
